import { create } from "zustand";
import dayjs from "dayjs";
import { useLocalStorage } from "react-use";

interface AvatarCreationPromptSlice {
    closePrompt(): void;
    isOpen: boolean;
    openPrompt(): void;
    setWillTrigger(value: boolean): void;
    willTrigger: boolean | undefined;
}

export const useAvatarCreationPromptStore = create<AvatarCreationPromptSlice>()(
    (set) => ({
        willTrigger: undefined,
        isOpen: false,
        openPrompt: () =>
            set(() => ({
                isOpen: true,
            })),
        closePrompt: () => set({ isOpen: false }),
        setWillTrigger: (value: boolean) => set({ willTrigger: value }),
    }),
);

export const useAvatarCreationPromptDismissalState = function () {
    const [dismissalDateTime, setStorage] = useLocalStorage<string>(
        "avatar:prompt:dismissal",
    );
    const diffThreshold = 30;
    const diffUnit = "day";

    return {
        storeDismissalDateTime: () => {
            setStorage(dayjs().toISOString());
        },
        dateTimeExpired: () => {
            return dismissalDateTime
                ? dayjs().diff(dismissalDateTime, diffUnit) >= diffThreshold
                : true;
        },
    };
};

export const useAvatarCreationPrompt = () => {
    const { openPrompt, willTrigger } = useAvatarCreationPromptStore();

    return {
        trigger: () => {
            if (!willTrigger) {
                return;
            }
            openPrompt();
        },
    };
};
